module.exports = __webpack_public_path__ + "img/b58ba88.png";